export default class CompareSearch {
    public attributeSetId = 0;
    public searchString = "";
    public brandId: number | null = null;

    constructor(attributeSetId: number) {
        this.attributeSetId = attributeSetId;
    }
}